/**
 * @file filters.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los filtros por defecto para todas las páginas
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-27
 * @modified 2026-03-26
 * @author DLTCode
 * @author Daniel Sentamans
 * @modified Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

import { MapFilters } from "@/features/map";
import { DashboardFilters } from "@/features/dashboard";
import { createFilters } from "@/lib/filters";

export const DEFAULT_PAGE = 1;
export const DEFAULT_SIZE = 10;

export const defaultUsersFilters = createFilters({
  mail: "",
  role: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultUsersActivityFilters = createFilters({
  email: "",
  activityStatus: "",
  role: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultReportsFilters = createFilters({
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultVerificationFilters = createFilters({
  mail: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultCompaniesFilters = createFilters({
  name: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultOneCompanyFilters = createFilters({
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultMapFilters = createFilters<MapFilters>({
  zoomLevel: 10,
  centerLat: undefined,
  centerLng: undefined,
  layerSearch: "",
});

export const defaultAnomaliesFilters = createFilters({
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
});

export const defaultDashboardFilters = createFilters<DashboardFilters>({
  groupBy: "week",
  elintBand: undefined,
});

export const defaultSignalHistoryFilters = createFilters({
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
  sort: [],
  recordingIds: "",
  recordingSearch: "",
});

export const defaultSignalRecordingsFilters = createFilters({
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_SIZE,
});

// Filtros para la página de finalización de registro
// Solo necesitamos manejar el parámetro `code` para poder eliminarlo
// de la URL tras un registro exitoso.
export const defaultFinishRegistrationFilters = createFilters({
  code: undefined as string | undefined,
});
